import { useEffect, useState } from 'react';

/**
 * Hook to measure container dimensions
 */
export function useContainerMeasurement(
  containerRef?: React.RefObject<HTMLDivElement>
) {
  const [containerWidth, setContainerWidth] = useState(0);

  // Measure container width with ResizeObserver
  useEffect(() => {
    const measureWidth = () => {
      if (containerRef?.current) {
        setContainerWidth(containerRef.current.clientWidth);
      }
    };

    measureWidth(); // Initial measurement

    const resizeObserver = new ResizeObserver(measureWidth);
    if (containerRef?.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, [containerRef]);

  return {
    containerWidth,
  };
}
